import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  BarElement,
  LineController,
  BarController,
  ArcElement,
  RadialLinearScale,
  ScatterController,
  BubbleController,
  PieController,
  DoughnutController,
  PolarAreaController,
  RadarController,
} from 'chart.js';

// Register ALL Chart.js components
Chart.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  LineController,
  BarController,
  ArcElement,
  RadialLinearScale,
  ScatterController,
  BubbleController,
  PieController,
  DoughnutController,
  PolarAreaController,
  RadarController
);

// Export Chart for use in components
export { Chart };

// Export all other components
export {
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  LineController,
  BarController,
  ArcElement,
  RadialLinearScale,
  ScatterController,
  BubbleController,
  PieController,
  DoughnutController,
  PolarAreaController,
  RadarController,
};
